var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"action menu",on:{"click":_vm.toggleVisibility}},[_c('img',{attrs:{"src":_vm.icon}}),_c('div',{staticClass:"menu-items",class:{visible: _vm.headerMenuVisible}},[_vm._t("default"),_c('div',{staticClass:"arrow"},[_vm._v("▲")])],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }